import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      height: '100vh',
    },
    row: {
      display: 'table-row',

      '&.top': {},

      '&.middle': {
        height: '100%',
      },
    },
    section: {
      display: 'table-cell',
      verticalAlign: 'top',

      '&.header': {
        position: 'sticky',
        top: 0,
        width: '100%',
        zIndex: 80,
      },
      '&.main': {
        height: '100%',
        position: 'unset',
        top: 'unset',
      },
      '&.footer': {
        position: 'relative',
      },
    },
  },
  {
    name: 'layout',
  },
);

export default useStyles;
